import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import DialogRegisterLogDetail from './DialogRegisterLogDetail';
import {
    addFromColumn,
    convertDate,
    convertStartEndDatesForFile,
    copyObjectArray,
    sortArrayByKey,
    sortCurrency,
    toCurrency,
} from '../shared/functions';
import {getGetHeaders} from '../shared/serverFunctions';
import {setDefaultTableSort, getTableState, filterCaseInsensitive} from '../shared/tableFunctions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import ReactTable from 'react-table';
import ReactToPrint from 'react-to-print';
import {CSVLink} from 'react-csv';
import {RESOURCES as reportsResources} from '../fuseReportsResourceMap';
import Config from '../messages';
import '../shared/react-table.css';
import {commonStyles} from '../shared/styles';
import {tableStyles} from '../shared/styles-table';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import DetailIcon from 'material-ui/svg-icons/image/remove-red-eye';
import ExportIcon from 'material-ui/svg-icons/navigation/arrow-downward';
import TableIcon from 'material-ui/svg-icons/action/receipt';
import CircularProgress from 'material-ui/CircularProgress';

/**
 * Class for retrieving and displaying Location Register Log Summary in a single table
 *
 */
class RegisterLogReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogOpen: false,
            logDetail: null,
            logLoading: false,
            reportName: 'Register Log',
            selectedSeq: null,
            summaryList: [],
            summaryTableData: [],
            summaryTableHeaders: [
                {label: 'ID', key: 'seq'},
                {label: 'Location', key: 'location_id'},
                {label: 'Register', key: 'register_id'},
                {label: 'User', key: 'user_id'},
                {label: 'Type', key: 'type'},
                {label: 'Open Till', key: 'till_open'},
                {label: 'Close Till', key: 'till_close'},
                {label: 'Close Cash Reported', key: 'close_cash_reported'},
                {label: 'Cash Sales', key: 'sales_cash'},
                {label: 'Credit Sales', key: 'sales_credit'},
                {label: 'Cash Refunds', key: 'credits_cash'},
                {label: 'Credit Refunds', key: 'credits_credit'},
                {label: 'Processed', key: 'date_string'}
            ],
            message: null,
            summaryComplete: false,
        };
        this.processLogData = this.processLogData.bind(this);
        this.processSeqData = this.processSeqData.bind(this);
        this.handleExportClick = this.handleExportClick.bind(this);
        this.handleSortOrFilterChange = this.handleSortOrFilterChange.bind(this);
    }

    componentWillMount() {
        this.fetchData('log');
    }

    componentWillReceiveProps(nextProps) {
        let clearTable = false;
        if (
            nextProps.endDate !== this.props.endDate ||
            nextProps.locationId !== this.props.locationId ||
            nextProps.offset !== this.props.offset ||
            nextProps.startDate !== this.props.startDate
        ) {
            clearTable = true;
        }
        if (clearTable) {
            this.setState({
                logDetail: null,
                logLoading: false,
                selectedSeq: null,
                summaryComplete: false,
                summaryList: [],
                summaryTableData: [],
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.endDate !== this.props.endDate ||
            prevProps.locationId !== this.props.locationId ||
            prevProps.offset !== this.props.offset ||
            prevProps.startDate !== this.props.startDate
        ) {
            this.fetchData('log');
        }
    }

    /* API Calls ------------------------------ */

    /**
     * Get data for Register Log or specific Seq
     * @param type
     */
    fetchData(type) {
        const params = {
            location_id: this.props.locationId
        };
        let resource;
        if (type === 'seq') {
            params.seq = this.state.selectedSeq;
            resource = reportsResources.RegisterLogInfoBySeq.GET_LIST(params);
        } else if (type === 'log') {
            params.start_date = this.props.startDate;
            params.end_date = this.props.endDate;
            params.offset = this.props.offset;
            resource = reportsResources.RegisterLogByLocationId.GET_LIST(params);
        }

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data && result.data.payload) {
                if (type === 'seq') {
                    this.processSeqData(result.data.payload);
                } else if (type === 'log') {
                    this.processLogData(result.data.payload);
                }
            }
        }).catch((error) => {
            let message = Config.fuse.error.error + this.state.reportName + '.';
            if (error.response) {
                // Server response outside 2xx
            } else if (error.request) {
                // No response
                message = Config.fuse.error.no_response + this.state.reportName + '.';
            } else {
                console.log('Error', error.message);
            }
            this.setState({
                summaryList: [],
                summaryTableData: [],
                summaryComplete: false,
            }, () => {
                if (typeof this.props.onError === 'function') {
                    this.props.onError('register', message);
                }
            });
        });
    }

    /* Data Processing ------------------------------ */

    /**
     * Store Register Log results
     *
     * @param data
     */
    processLogData(data) {

        let list = copyObjectArray(this.state.summaryList);
        const emptyCurrency = toCurrency(0);

        let dataLength = data.length;
        if (dataLength) {
            for (let i = 0; i < dataLength; i++) {
                let item = data[i];

                let date = '(No Date)';
                let dateString = '(No Date)';
                if (item.modified) {
                    date = item.modified;
                    dateString = convertDate(item.modified, 'display', true, true, this.props.offset, true);
                }

                let row = {
                    date: date,
                    date_string: dateString,
                    location_id: (item.location_id) ? item.location_id : '----',
                    register_id: (item.register_id) ? item.register_id : '----',
                    seq: (item.seq) ? item.seq : '',
                    system: (item.system) ? item.system : '',
                    type: (item.type) ? item.type : '',
                    user_id: (item.user_id) ? item.user_id : '----',
                    till_open: (item.till_open) ? toCurrency(item.till_open) : emptyCurrency,
                    till_close: (item.till_close) ? toCurrency(item.till_close) : emptyCurrency,
                    close_cash_reported: (item.close_cash_reported) ? toCurrency(item.close_cash_reported) : emptyCurrency,
                    sales_cash: (item.sales_cash) ? toCurrency(item.sales_cash) : emptyCurrency,
                    sales_credit: (item.sales_credit) ? toCurrency(item.sales_credit) : emptyCurrency,
                    credits_cash: (item.credits_cash) ? toCurrency(item.credits_cash) : emptyCurrency,
                    credits_credit: (item.credits_credit) ? toCurrency(item.credits_credit) : emptyCurrency,
                };
                list.push(row);
            }
        }
        const sortedList = sortArrayByKey(list, 'date', 'DESC');

        // Finalize table data
        this.setState({
            summaryList: sortedList,
            summaryTableData: sortedList,
            summaryComplete: true
        }, () => {
            this.props.onSummaryComplete('register', true);
        });
    }

    /**
     * Store data for requested Seq
     *
     * @param data
     */
    processSeqData(data) {
        let item = (data.length) ? data[0] : data;
        const emptyCurrency = toCurrency(0);

        let date = '(No Date)';
        let dateString = '(No Date)';
        let dateClose = '(No Date)';
        let dateCloseString = '(No Date)';
        let dateOpen = '(No Date)';
        let dateOpenString = '(No Date)';
        if (item.modified) {
            date = item.modified;
            dateString = convertDate(item.modified, 'display', true, true, this.props.offset, true);
        }
        if (item.register_close) {
            dateClose = item.register_close;
            dateCloseString = convertDate(item.register_close, 'display', true, true, this.props.offset, true);
        }
        if (item.register_open) {
            dateOpen = item.register_open;
            dateOpenString = convertDate(item.register_open, 'display', true, true, this.props.offset, true);
        }

        let logDetail = {
            date: date,
            date_string: dateString,
            device_id: (item.device_id) ? item.device_id : '----',
            location_id: (item.location_id) ? item.location_id : '----',
            register_id: (item.register_id) ? item.register_id : '----',
            register_close: dateClose,
            register_close_string: dateCloseString,
            register_open: dateOpen,
            register_open_string: dateOpenString,
            seq: (item.seq) ? item.seq : '',
            signature: (item.close_signature) ? item.close_signature : '',
            system: (item.system) ? item.system : '',
            type: (item.type) ? item.type : '',
            user_id: (item.user_id) ? item.user_id : '----',
            version: (item.client && item.client.version) ? item.client.version : '',
            till_open: (item.till_open) ? toCurrency(item.till_open) : emptyCurrency,
            till_close: (item.till_close) ? toCurrency(item.till_close) : emptyCurrency,
            close_cash_reported: (item.close_cash_reported) ? toCurrency(item.close_cash_reported) : emptyCurrency,
            sales_cash: (item.sales_cash) ? toCurrency(item.sales_cash) : emptyCurrency,
            sales_credit: (item.sales_credit) ? toCurrency(item.sales_credit) : emptyCurrency,
            credits_cash: (item.credits_cash) ? toCurrency(item.credits_cash) : emptyCurrency,
            credits_credit: (item.credits_credit) ? toCurrency(item.credits_credit) : emptyCurrency,
            number_of_credits_cash: (item.number_of_credits_cash) ? item.number_of_credits_cash : '0',
            number_of_credits_credit: (item.number_of_credits_credit) ? item.number_of_credits_credit : '0',
            number_of_discounts: (item.number_of_discounts) ? item.number_of_discounts : '0',
            number_of_payments_cash: (item.number_of_payments_cash) ? item.number_of_payments_cash : '0',
            number_of_payments_credit: (item.number_of_payments_credit) ? item.number_of_payments_credit : '0',
            number_of_withdrawals: (item.number_of_withdrawals) ? item.number_of_withdrawals : '0',
            sales_tax_collected: (item.sales_tax_collected) ? item.sales_tax_collected : '0',
            sales_tax_refunded_cash: (item.sales_tax_refunded_cash) ? item.sales_tax_refunded_cash : '0',
            sales_tax_refunded_credit: (item.sales_tax_refunded_credit) ? item.sales_tax_refunded_credit : '0',
            withdrawals: (item.withdrawals) ? toCurrency(item.withdrawals) : emptyCurrency,
        };

        this.setState({
            logDetail: logDetail,
            logLoading: false
        });
    }

    /* Table Building ------------------------------ */

    /**
     * Update selected table data based on sort
     *
     * @param event
     * @param table
     */
    handleSortOrFilterChange(event, table) {
        const tableData = getTableState(table);
        if (tableData && tableData.length > 0) {
            this.setState({
                summaryTableData: tableData
            });
        }
    }

    /**
     * Handle event to retrieve current state of table data
     *
     * @param event
     */
    handleExportClick = (event) => {
        // CSVLink handles generation and export of CSV
    };

    /**
     * Handle event to fetch Log details for detail dialog
     */
    handleSelectSeq = (event, seq) => {
        this.setState({
            dialogOpen: true,
            logLoading: true,
            selectedSeq: seq
        }, () => {
            this.fetchData('seq');
        });
    };

    /**
     * Handle event to close detail dialog
     */
    handleCloseDialog = () => {
        this.setState({
            dialogOpen: false,
            logDetail: null
        });
    };

    /* Table Display ------------------------------ */

    render() {

        const {
            endDate,
            startDate,
            system,
        } = this.props;

        const {
            dialogOpen,
            logDetail,
            logLoading,
            summaryList,
            summaryTableData,
            summaryTableHeaders,
            summaryComplete,
        } = this.state;

        const dateString = convertStartEndDatesForFile(startDate, endDate);
        const defaultSort = setDefaultTableSort('date', 'DESC');

        const dialogActions = [
            <FlatButton
                label="Close"
                primary={true}
                onClick={this.handleCloseDialog}
            />
        ];

        // ReactTable headers and columns for Table
        const tableColumns = [
            {
                Header: 'Register Info',
                columns: [
                    {
                        Header: 'ID',
                        accessor: 'seq',
                        width: 240,
                        Cell: props => (
                            <span>
                                <span>{props.row.seq}</span>
                                <DetailIcon
                                    onClick={(e) => this.handleSelectSeq(e, props.row.seq)}
                                    style={tableStyles.tableIconButton}
                                />
                            </span>
                        ),
                    },
                    {
                        Header: 'Location',
                        accessor: 'location_id',
                    },
                    {
                        Header: 'Register',
                        accessor: 'register_id',
                    },
                    {
                        Header: 'User',
                        accessor: 'user_id',
                    },
                    {
                        Header: 'Type',
                        accessor: 'type',
                    }
                ]
            },
            {
                Header: 'Till',
                columns: [
                    {
                        Header: 'Open Till',
                        accessor: 'till_open',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right
                    },
                    {
                        Header: 'Close Till',
                        accessor: 'till_close',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'till_close'))}
                            </span>
                        )
                    },
                    {
                        Header: 'Close Cash Reported',
                        accessor: 'close_cash_reported',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'close_cash_reported'))}
                            </span>
                        )
                    }
                ]
            },
            {
                Header: 'Sales & Refunds',
                columns: [
                    {
                        Header: 'Cash Sales',
                        accessor: 'sales_cash',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'sales_cash'))}
                            </span>
                        )
                    },
                    {
                        Header: 'Credit Sales',
                        accessor: 'sales_credit',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'sales_credit'))}
                            </span>
                        )
                    },
                    {
                        Header: 'Cash Refunds',
                        accessor: 'credits_cash',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'credits_cash'))}
                            </span>
                        )
                    },
                    {
                        Header: 'Credit Refunds',
                        accessor: 'credits_credit',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'credits_credit'))}
                            </span>
                        )
                    }
                ]
            },
            {
                Header: '',
                columns: [
                    {
                        Header: 'Processed',
                        accessor: 'date',
                        Cell: row => (
                            <span>{row.original.date_string}</span>
                        ),
                        width: 150
                    }
                ]
            }
        ];

        const printColumns = [
            {
                Header: 'Register Info',
                columns: [
                    {
                        Header: 'ID',
                        accessor: 'seq',
                        width: 224
                    },
                    {
                        Header: 'Location',
                        accessor: 'location_id',
                    },
                    {
                        Header: 'Register',
                        accessor: 'register_id',
                    },
                    {
                        Header: 'User',
                        accessor: 'user_id',
                    },
                    {
                        Header: 'Type',
                        accessor: 'type',
                    }
                ]
            },
            {
                Header: 'Till',
                columns: [
                    {
                        Header: 'Open Till',
                        accessor: 'till_open',
                        style: tableStyles.right
                    },
                    {
                        Header: 'Close Till',
                        accessor: 'till_close',
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryList, 'till_close'))}
                            </span>
                        )
                    },
                    {
                        Header: 'Close Cash Reported',
                        accessor: 'close_cash_reported',
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryList, 'close_cash_reported'))}
                            </span>
                        )
                    }
                ]
            },
            {
                Header: 'Sales & Refunds',
                columns: [
                    {
                        Header: 'Cash Sales',
                        accessor: 'sales_cash',
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryList, 'sales_cash'))}
                            </span>
                        )
                    },
                    {
                        Header: 'Credit Sales',
                        accessor: 'sales_credit',
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryList, 'sales_credit'))}
                            </span>
                        )
                    },
                    {
                        Header: 'Cash Refunds',
                        accessor: 'credits_cash',
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryList, 'credits_cash'))}
                            </span>
                        )
                    },
                    {
                        Header: 'Credit Refunds',
                        accessor: 'credits_credit',
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryList, 'credits_credit'))}
                            </span>
                        )
                    }
                ]
            },
            {
                Header: '',
                columns: [
                    {
                        Header: 'Processed',
                        accessor: 'date',
                        Cell: props => (
                            <span>{props.row.date_string}</span>
                        )
                    }
                ]
            }
        ];

        return (
            <div>
                {summaryComplete &&
                <div className="reports-table-container">

                    {/* Table Header: Register Log */}
                    <div className="reports-table-title table-table-header">
                        <div className="btn-report-container report-header-button-container">
                            {/* Export Register Log */}
                            <FlatButton
                                primary
                                type="button"
                                label=""
                                style={commonStyles.headerButton}
                            >
                                <ExportIcon style={commonStyles.headerButtonIcon}/>
                                <CSVLink
                                    data={summaryTableData}
                                    headers={summaryTableHeaders}
                                    filename={'Register-Log-' + system + '-' + dateString + '.csv'}
                                    onClick={(e) => this.handleExportClick(e)}
                                    target="_blank"
                                    style={commonStyles.headerButtonLink}
                                >
                                    Export Register Log
                                </CSVLink>
                            </FlatButton>
                        </div>
                        <h3 className="table-table-header-title">
                            <TableIcon style={commonStyles.summaryIcon}/>
                            <span>Register Log</span>
                        </h3>
                    </div>

                    {/* Table: Register Log */}
                    <ReactTable
                        key="table-register-log"
                        data={summaryList}
                        columns={tableColumns}
                        defaultPageSize={10}
                        showPagination={true}
                        defaultSorted={defaultSort}
                        filterable
                        defaultFilterMethod={filterCaseInsensitive}
                        onSortedChange={(e) => this.handleSortOrFilterChange(e, this.registerLogReactTable)}
                        onFilteredChange={(e) => this.handleSortOrFilterChange(e, this.registerLogReactTable)}
                        ref={(r) => this.registerLogReactTable = r}
                        resizable={false}
                        minRows={1}
                        className="-striped overflow no-print"
                    />
                    <ReactTable
                        key="table-register-log-print"
                        data={summaryTableData}
                        columns={printColumns}
                        defaultPageSize={10000}
                        showPagination={false}
                        resizable={false}
                        minRows={1}
                        className="-striped print-only"
                    />

                    {/* Detail Dialog */}
                    <Dialog
                        modal={false}
                        open={dialogOpen}
                        onRequestClose={this.handleCloseDialog}
                        autoScrollBodyContent={true}
                        actions={dialogActions}
                    >
                        <ReactToPrint
                            trigger={() =>
                                <RaisedButton
                                    primary
                                    type="button"
                                    label="Print Log Detail"
                                    className="dialog-btn-print"
                                />
                            }
                            content={() => this.registerPrintRef}
                        />
                        <h3 className="dialog-title">Register Log Detail</h3>
                        {logLoading && !logDetail &&
                            <div className="loader-container">
                                <h4>Generating Register Log Detail...</h4>
                                <CircularProgress
                                    size={24}
                                    thickness={2}
                                    className="loader"
                                />
                            </div>
                        }
                        {logDetail &&
                        <DialogRegisterLogDetail
                            data={logDetail}
                            ref={el => (this.registerPrintRef = el)}
                        />
                        }
                    </Dialog>
                </div>
                }
            </div>
        )
    }
}

RegisterLogReport.propTypes = {
    endDate: PropTypes.string,
    locationId: PropTypes.string,
    offset: PropTypes.string.isRequired,
    onDisplayMessage: PropTypes.func,
    onError: PropTypes.func,
    onSummaryComplete: PropTypes.func,
    startDate: PropTypes.string,
    system: PropTypes.string,
};

RegisterLogReport.defaultProps = {
    endDate: null,
    locationId: null,
    offset: null,
    startDate: null,
};

export default RegisterLogReport;



// WEBPACK FOOTER //
// ./src/Fuse/components/RegisterLogReport.js